<template>
    <div class="uDialog">
        <el-dialog :title="title" :width="width" :visible="visible" :top="top" v-bind="$props" @close="close" :closeOnClickModal="false">
      <slot></slot>
      <div slot="footer" class="dialog-footer">
        <span class="searchBtn" @click="confirm">{{$t("uDialog.txt1")}}</span>
        <span class="searchBtn ml20 borderBtn noBorder" @click="close">{{$t("uDialog.txt2")}}</span>
      </div>
    </el-dialog>
    </div>
    
</template>

<script>
export default {
    name: 'u-dialog',
    inheritAttrs: false,
    props: {
        visible: Boolean,
        title: String,
        width: {
            type: String,
            default: '50%'
        },
        top: {
            type: String,
            default: '5vh',
        },
    },
    data() {
        return {
            customVisible: false,
        };
    },
    methods: {
        close() {
            this.$emit('update:visible', false)
        },
        confirm() {
            this.$emit('confirm')
        },
    },
};
</script>
<style lang="less">
     
</style>
